var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureStorSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a41",
    x1: 9,
    y1: 13.5,
    x2: 9,
    y2: 0.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1380da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#559cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.5a4.06 4.06 0 00-3.51-3.89A5.1 5.1 0 009.24.74a5.23 5.23 0 00-5 3.41A4.82 4.82 0 000 8.79a4.9 4.9 0 005.07 4.71h8.65a1.46 1.46 0 00.22 0 4.1 4.1 0 004.06-4z",
    fill: "url(#a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.23,
    y: 16.36,
    width: 4.25,
    height: 0.9,
    rx: 0.3,
    fill: "#198ab3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.23,
    y: 14.45,
    width: 4.25,
    height: 0.9,
    rx: 0.3,
    fill: "#32bedd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.23,
    y: 12.55,
    width: 4.25,
    height: 0.9,
    rx: 0.3,
    fill: "#50e6ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.95,
    y: 7.8,
    width: 4.25,
    height: 0.9,
    rx: 0.3,
    fill: "#f2f2f2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.95,
    y: 9.55,
    width: 4.25,
    height: 0.9,
    rx: 0.3,
    fill: "#f2f2f2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.95,
    y: 11.31,
    width: 4.25,
    height: 0.9,
    rx: 0.3,
    fill: "#f2f2f2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureStorSimple);
export default __webpack_public_path__ + "static/media/azure-storSimple.3a495fbfc58b6a8b47fddfd0e05ec6f3.svg";
export { ForwardRef as ReactComponent };